import React, {Component} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import BasicInput from '../common/BasicInput';
import BasicSelect from '../common/BasicSelect';
import MobileInput from '../common/MobileInput';
import {
    register,
    getProvinceList,
    getCityList,
    validEmailRegister,
} from 'Actions/register';
import {openNotification} from 'Actions/notification';
import BasicButton from 'Components/common/BasicButton';
import {T} from 'Actions/translate';
import {Link} from '@material-ui/core';
import {
    useClausesUrl,
    termsConditionUrl,
    privacyUrl,
    pricingConsignmentUrl,
} from 'Utils/urlUtil';

class Register extends Component {
    state = {
        checked: false,
        isEmail: true,
        isMobile: true,
        isShipToPhone: true,
        isBillToPhone: true,
        isRegisterEmail: true,
        receiveNotification: '1',
        firstName: '',
        lastName: '',
        institution: '',
        labOrDept: '',
        mobile: '',
        email: '',
        shipToName: '',
        shipToPhone: '',
        shipToStateId: '',
        shipToCityId: '',
        shipToAddress: '',
        billToName: '',
        billToPhone: '',
        invoiceTitle: '',
        billToStateId: '',
        billToCityId: '',
        billToAddress: '',
        mobileSelect: '0',
        shipToSelect: '0',
        billToSelect: '0',
    };

    componentWillMount() {
        this.props.getProvinceList();
    }

    setMobileSelect = (value) => {
        this.setState({
            mobileSelect: value,
            isMobile: true,
        });
    };

    setShipToSelect = (value) => {
        if (this.state.checked === true) {
            this.setState({
                shipToSelect: value,
                billToSelect: value,
                isShipToPhone: true,
            });
        } else {
            this.setState({
                shipToSelect: value,
                isShipToPhone: true,
            });
        }
    };

    setBillToSelect = (value) => {
        this.setState({
            billToSelect: value,
            isBillToPhone: true,
        });
    };

    handleChange = (name, value) => {
        const reEmail =
            /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
        const reMobile = /^1[34578][0-9]\s[0-9]{4}\s[0-9]{4}$/;

        switch (name) {
            case 'shipToStateId':
                this.props.getCityList(value, 'shipTo');
                this.setState({shipToCityId: ''});
                break;
            case 'billToStateId':
                this.props.getCityList(value, 'billTo');
                this.setState({billToCityId: ''});
                break;
            case 'mobile':
                if (this.state.mobileSelect === '0') {
                    const isMobile = reMobile.test(value);
                    this.setState({isMobile: isMobile});
                }
                break;
            case 'shipToPhone':
                if (this.state.shipToSelect === '0') {
                    const isShipToPhone = reMobile.test(value);
                    this.setState({isShipToPhone: isShipToPhone});
                }
                break;
            case 'billToPhone':
                if (this.state.billToSelect === '0') {
                    const isBillToPhone = reMobile.test(value);
                    this.setState({isBillToPhone: isBillToPhone});
                }
                break;
            case 'email':
                const isEmail = reEmail.test(value);
                this.setState({isEmail: isEmail});
                break;
            default:
                break;
        }

        if (this.state.checked) {
            this.copyShipToInfo(name, value);
        } else {
            this.setState({[name]: value});
        }
    };

    copyShipToInfo(name, value) {
        switch (name) {
            case 'shipToName':
                this.setState({
                    shipToName: value,
                    billToName: value,
                });
                break;
            case 'shipToPhone':
                this.setState({
                    shipToPhone: value,
                    billToPhone: value,
                });
                break;
            case 'shipToSelect':
                this.setState({
                    shipToSelect: value,
                    billToSelect: value,
                });
                break;
            case 'shipToStateId':
                this.setState({
                    shipToStateId: value,
                    billToStateId: value,
                });
                this.props.getCityList(value, 'shipTo');
                this.props.getCityList(value, 'billTo');
                break;
            case 'shipToCityId':
                this.setState({
                    shipToCityId: value,
                    billToCityId: value,
                });
                break;
            case 'shipToAddress':
                this.setState({
                    shipToAddress: value,
                    billToAddress: value,
                });
                break;
            default:
                this.setState({[name]: value});
                break;
        }
    }

    handleChangeCheckbox = (name) => (event) => {
        if (event.target.checked) {
            this.props.getCityList(this.state.shipToStateId, 'billTo');
            this.setState({
                billToName: this.state.shipToName,
                billToPhone: this.state.shipToPhone,
                billToSelect: this.state.shipToSelect,
                billToStateId: this.state.shipToStateId,
                billToCityId: this.state.shipToCityId,
                billToAddress: this.state.shipToAddress,
                [name]: event.target.checked,
            });
        } else {
            this.setState({[name]: event.target.checked});
        }
    };

    handleChangeRadio = (event) => {
        this.setState({receiveNotification: event.target.value});
    };

    /**
     *  Send To Backend Request Register
     */
    handleRegister = () => {
        const data = {
            baseInfo: {
                receiveNotification: this.state.receiveNotification,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                institution: this.state.institution,
                labOrDept: this.state.labOrDept,
                mobile: this.state.mobile.replace(/\s*/g, ''),
                email: this.state.email,
            },
            profile: {
                shipToName: this.state.shipToName,
                shipToPhone: this.state.shipToPhone.replace(/\s*/g, ''),
                shipToStateId: this.state.shipToStateId,
                shipToCityId: this.state.shipToCityId,
                shipToAddress: this.state.shipToAddress,
                billToName: this.state.billToName,
                billToPhone: this.state.billToPhone.replace(/\s*/g, ''),
                invoiceTitle: this.state.invoiceTitle,
                billToStateId: this.state.billToStateId,
                billToCityId: this.state.billToCityId,
                billToAddress: this.state.billToAddress,
            },
        };

        if (this.state.lastName === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('lastName'),
                'danger',
            );
        } else if (this.state.firstName === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('firstName'),
                'danger',
            );
        } else if (this.state.institution === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('institution'),
                'danger',
            );
        } else if (this.state.labOrDept === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('labOrDept'),
                'danger',
            );
        } else if (this.state.mobile === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('contactInformation'),
                'danger',
            );
        } else if (!this.state.isMobile) {
            this.props.openNotification(T('errorMobile'), 'danger');
        } else if (this.state.email === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('email'),
                'danger',
            );
        } else if (!this.state.isEmail) {
            this.props.openNotification(T('errorEmail'), 'danger');
        } else if (this.state.shipToName === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('shipInfo') + T('shipToName'),
                'danger',
            );
        } else if (this.state.shipToPhone === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('shipToPhone'),
                'danger',
            );
        } else if (!this.state.isShipToPhone) {
            this.props.openNotification(
                T('shipInfo') + T('errorMobile'),
                'danger',
            );
        } else if (this.state.shipToStateId === '') {
            this.props.openNotification(
                T('pleaseSelect') + T('shipInfo') + T('shipToStateId'),
                'danger',
            );
        } else if (this.state.shipToCityId === '') {
            this.props.openNotification(
                T('pleaseSelect') + T('shipInfo') + T('shipToCityId'),
                'danger',
            );
        } else if (this.state.shipToAddress === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('shipInfo') + T('shipToAddress'),
                'danger',
            );
        } else if (this.state.billToName === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('billInfo') + T('billToName'),
                'danger',
            );
        } else if (this.state.billToPhone === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('billToPhone'),
                'danger',
            );
        } else if (!this.state.isBillToPhone) {
            this.props.openNotification(
                T('billInfo') + T('errorMobile'),
                'danger',
            );
        } else if (this.state.invoiceTitle === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('invoiceTitle'),
                'danger',
            );
        } else if (this.state.billToStateId === '') {
            this.props.openNotification(
                T('pleaseSelect') + T('billInfo') + T('billToStateId'),
                'danger',
            );
        } else if (this.state.billToCityId === '') {
            this.props.openNotification(
                T('pleaseSelect') + T('billInfo') + T('billToCityId'),
                'danger',
            );
        } else if (this.state.billToAddress === '') {
            this.props.openNotification(
                T('pleaseEnter') + T('billInfo') + T('billToAddress'),
                'danger',
            );
        } else if (this.props.emailValidRegister.status === 'invalid_email') {
            this.props.openNotification(T('duplicateEmail'), 'danger');
        } else {
            this.props.register(data, this.registerNotification);
        }
    };

    registerNotification = (res) => {
        if (res.status === 'success') {
            this.props.openNotification(T('registerSuccess'), 'success');
            this.props.onChangeIndex(0);
        } else {
            this.props.openNotification(T('registerFailure'), 'danger');
        }
    };

    validEmail = () => {
        if (this.state.email) {
            this.props.validEmailRegister(
                this.state.email,
                this.registerValidEmail,
            );
        }
    };

    registerValidEmail = (res) => {
        if (res.status === 'invalid_email') {
            this.setState({isRegisterEmail: true});
        } else {
            this.setState({isRegisterEmail: false});
        }
    };

    resetRegisterEmail = () => {
        this.setState({isRegisterEmail: false});
    };

    render() {
        const {emailValidRegister} = this.props;
        const {
            isEmail,
            isMobile,
            isShipToPhone,
            isBillToPhone,
            isRegisterEmail,
        } = this.state;
        const provinceList =
            this.props.provinceList && this.props.provinceList.data;
        const shipToCityList =
            this.props.shipToCityList && this.props.shipToCityList.data;
        const billToCityList =
            this.props.billToCityList && this.props.billToCityList.data;

        return (
            <div className="register">
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <div className="register-notice">{T('noticeOne')}</div>
                    </Grid>
                </Grid>

                <Grid container spacing={0}>
                    <Grid className="register-grid-title" item xs={12}>
                        <div className="register-title">{T('baseInfo')}</div>
                    </Grid>
                </Grid>

                <Grid className="register-grid" container spacing={0}>
                    <Grid className="name-grid last-name" item xs={6}>
                        <BasicInput
                            title={'lastName'}
                            placeholder=""
                            inputValid={this.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                    <Grid className="name-grid first-name" item xs={6}>
                        <BasicInput
                            title={'firstName'}
                            placeholder=""
                            inputValid={this.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                </Grid>

                <Grid
                    className="register-grid padding-bottom-15"
                    container
                    spacing={0}>
                    <Grid className="institution-grid" item xs={12}>
                        <BasicInput
                            title={'institution'}
                            placeholder=""
                            inputValid={this.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <BasicInput
                            title={'labOrDept'}
                            placeholder=""
                            inputValid={this.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MobileInput
                            status="1"
                            title={'mobile'}
                            placeholder=""
                            selectValue={this.state.mobileSelect}
                            setSelect={this.setMobileSelect}
                            inputValid={this.handleChange}
                            required="true"
                        />
                    </Grid>
                    {!isMobile ? (
                        <Grid item xs={12}>
                            <span className="error-msg">
                                {T('errorMobile')}
                            </span>
                        </Grid>
                    ) : null}
                    <Grid
                        className={
                            isEmail &&
                            isRegisterEmail &&
                            emailValidRegister.status === 'invalid_email'
                                ? 'email-valid'
                                : ''
                        }
                        item
                        xs={12}>
                        <BasicInput
                            title={'email'}
                            placeholder=""
                            inputValid={this.handleChange}
                            blurFoucus={this.resetRegisterEmail}
                            blurAction={this.validEmail}
                            type="email"
                            required="true"
                        />
                    </Grid>
                    {!isEmail ? (
                        <Grid item xs={12}>
                            <span className="error-msg">{T('errorEmail')}</span>
                        </Grid>
                    ) : null}
                    {isEmail &&
                    isRegisterEmail &&
                    emailValidRegister.status === 'invalid_email' ? (
                        <Grid item xs={12}>
                            <span className="error-msg">
                                {T('duplicateEmail')}
                            </span>
                        </Grid>
                    ) : null}
                </Grid>

                <Grid container spacing={0}>
                    <Grid className="register-grid-title" item xs={12}>
                        <div className="register-title">{T('shipInfo')}</div>
                    </Grid>
                </Grid>

                <Grid className="register-grid" container spacing={0}>
                    <Grid item xs={12}>
                        <BasicInput
                            title={'shipToName'}
                            placeholder=""
                            value={this.state.shipToName}
                            inputValid={this.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MobileInput
                            status="1"
                            selectValue={this.state.shipToSelect}
                            setSelect={this.setShipToSelect}
                            title={'shipToPhone'}
                            placeholder=""
                            value={this.state.shipToPhone}
                            inputValid={this.handleChange}
                            required="true"
                        />
                    </Grid>
                    {!isShipToPhone ? (
                        <Grid item xs={12}>
                            <span className="error-msg">
                                {T('errorMobile')}
                            </span>
                        </Grid>
                    ) : null}
                </Grid>

                <Grid className="register-grid" container spacing={0}>
                    <Grid className="state-grid" item xs={6}>
                        <BasicSelect
                            title={'shipToStateId'}
                            placeholder=""
                            value={this.state.shipToStateId}
                            selectList={provinceList}
                            handleChange={this.handleChange}
                        />
                    </Grid>
                    <Grid className="city-grid" item xs={6}>
                        <BasicSelect
                            title={'shipToCityId'}
                            placeholder=""
                            value={this.state.shipToCityId}
                            selectList={shipToCityList}
                            handleChange={this.handleChange}
                        />
                    </Grid>
                </Grid>

                <Grid
                    className="register-grid padding-bottom-15"
                    container
                    spacing={0}>
                    <Grid item xs={12}>
                        <BasicInput
                            title={'shipToAddress'}
                            placeholder=""
                            value={this.state.shipToAddress}
                            inputValid={this.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={0}>
                    <Grid className="register-grid-title" item xs={6}>
                        <div className="register-title">{T('billInfo')}</div>
                    </Grid>
                    <Grid className="register-grid-title" item xs={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.checked}
                                    onChange={this.handleChangeCheckbox(
                                        'checked',
                                    )}
                                    className="register-checkbox"
                                />
                            }
                            label={T('sameShipInfo')}
                            className={`register-checkbox-label ${
                                this.state.checked ? 'checked' : ''
                            }`}
                        />
                    </Grid>
                </Grid>

                <Grid className="register-grid" container spacing={0}>
                    <Grid item xs={12}>
                        <BasicInput
                            title={'billToName'}
                            placeholder=""
                            value={this.state.billToName}
                            inputValid={this.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MobileInput
                            status="1"
                            selectValue={this.state.billToSelect}
                            setSelect={this.setBillToSelect}
                            title={'billToPhone'}
                            placeholder=""
                            value={this.state.billToPhone}
                            inputValid={this.handleChange}
                            required="true"
                        />
                    </Grid>
                    {!isBillToPhone ? (
                        <Grid item xs={12}>
                            <span className="error-msg">
                                {T('errorMobile')}
                            </span>
                        </Grid>
                    ) : null}
                    <Grid item xs={12}>
                        <BasicInput
                            title={'invoiceTitle'}
                            placeholder=""
                            value={this.state.invoiceTitle}
                            inputValid={this.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                </Grid>

                <Grid className="register-grid" container spacing={0}>
                    <Grid className="state-grid" item xs={6}>
                        <BasicSelect
                            title={'billToStateId'}
                            placeholder=""
                            value={this.state.billToStateId}
                            selectList={provinceList}
                            handleChange={this.handleChange}
                        />
                    </Grid>
                    <Grid className="city-grid" item xs={6}>
                        <BasicSelect
                            title={'billToCityId'}
                            placeholder=""
                            value={this.state.billToCityId}
                            selectList={billToCityList}
                            handleChange={this.handleChange}
                        />
                    </Grid>
                </Grid>

                <Grid
                    className="register-grid padding-bottom-15"
                    container
                    spacing={0}>
                    <Grid item xs={12}>
                        <BasicInput
                            title={'billToAddress'}
                            placeholder=""
                            value={this.state.billToAddress}
                            inputValid={this.handleChange}
                            type="text"
                            required="true"
                        />
                    </Grid>
                </Grid>

                <Grid className="register-grid" item xs={12}>
                    <div className="content-text">
                        {T('receiveNotification')}
                    </div>
                </Grid>

                <Grid
                    className="register-grid padding-bottom-15"
                    container
                    spacing={0}>
                    <Grid item xs={12}>
                        <FormControl
                            component="fieldset"
                            className="register-radio-label">
                            <RadioGroup
                                aria-label="Gender"
                                name="gender"
                                className="register-radio-group"
                                value={this.state.receiveNotification}
                                onChange={this.handleChangeRadio}>
                                <FormControlLabel
                                    className={`register-radio ${
                                        this.state.receiveNotification === '1'
                                            ? 'checked'
                                            : ''
                                    }`}
                                    value="1"
                                    control={<Radio />}
                                    label="是"
                                />
                                <FormControlLabel
                                    className={`register-radio ${
                                        this.state.receiveNotification === '2'
                                            ? 'checked'
                                            : ''
                                    }`}
                                    value="2"
                                    control={<Radio />}
                                    label="否"
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid
                    className="register-grid padding-bottom-15"
                    container
                    spacing={0}>
                    <Grid className="" item xs={12}>
                        <BasicButton
                            type="primary"
                            className="register-button"
                            disabled={false}
                            onClickOfSingleTap={this.handleRegister}>
                            {T('registerAccount')}
                        </BasicButton>
                    </Grid>
                </Grid>

                <Grid className="register-grid padding-bottom-15" item xs={12}>
                    <div className="content-text">{T('noticeTwo')}</div>
                    <div className="content-text">
                        (1) {T('thermofisher')}
                        <Link href={useClausesUrl} className="red">
                            {T('useClauses')}
                        </Link>
                    </div>
                    <div className="content-text">
                        (2) {T('noticeThree')}
                        <Link href={termsConditionUrl} className="red">
                            {T('termsConditions')}
                        </Link>
                    </div>
                    <div className="content-text">
                        (3){' '}
                        <Link href={privacyUrl} className="red">
                            {T('privacy')}
                        </Link>
                    </div>
                    <div className="content-text">
                        (4){' '}
                        <Link href={pricingConsignmentUrl} className="red">
                            {T('pricingConsignment')}
                        </Link>
                    </div>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {register} = state;
    return {
        registerUser: register.registerUser,
        emailValidRegister: register.emailValidRegister,
        provinceList: register.provinceList,
        shipToCityList: register.shipToCityList,
        billToCityList: register.billToCityList,
    };
};

const mapDispatchToProps = {
    register,
    validEmailRegister,
    openNotification,
    getProvinceList,
    getCityList,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
)(Register);
